import { en } from './en'
import { es } from './es'

export type LanguageType = 'en' | 'es'
export type TranslationKey = keyof typeof en

export const translations = {
  en,
  es,
} as const

export type Translations = typeof translations 